import React from "react";
import styles from "./Hero.module.css";

export default function Hero({
  eyebrow,
  headline,
  body,
  children,
  size = "large",
  bgImage,
  bgVideo, // NEW
}) {
  const containerClass =
    size === "small"
      ? `${styles.heroContainer} ${styles.heroSmall}`
      : styles.heroContainer;

  return (
    <div className={containerClass}>
      {bgVideo ? (
        <video
          className={styles.heroBgVideo}
          src={bgVideo}
          autoPlay
          loop
          muted
          playsInline
        />
      ) : bgImage ? (
        <div
          className={styles.heroBgImage}
          style={{
            backgroundImage: `url(${bgImage})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        />
      ) : null}
      <div className={styles.heroOverlay}>
        <div className={styles.heroText}>
          {size !== "small" && eyebrow && (
            <span className={styles.heroEyebrow}>{eyebrow}</span>
          )}
          {headline && (
            <div className={styles.heroHeadline}>
              {headline}
            </div>
          )}
          {body && (
            <div className={styles.heroBody}>
              {body}
            </div>
          )}
          {children}
        </div>
      </div>
    </div>
  );
}
